import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import AppNavBar from "./AppNavBar";
import Product from "../sections/product/Product";
import Terms from "../sections/policy/Terms";
import { AppLinkHrefs } from "../navigation/navigationHelpers";
import BookChapter, { Chapter } from "../sections/book/BookChapter";
import Subscribe from "../sections/subscribe/Subscribe";
import Gumroad from "../sections/gumroad/Gumroad";
import Resources from "../sections/resources/Resources";

function AppLayout() {
  return (
    <React.Fragment>
      <Router>
        <AppNavBar />
        <Switch>
          <Route path={AppLinkHrefs.Introduction}>
            <BookChapter chapter={Chapter.Introduction} />
          </Route>
          <Route path={AppLinkHrefs.Chapter1}>
            <BookChapter chapter={Chapter.Chapter1} />
          </Route>
          <Route path={AppLinkHrefs.Chapter2}>
            <BookChapter chapter={Chapter.Chapter2} />
          </Route>
          <Route path={AppLinkHrefs.Chapter3}>
            <BookChapter chapter={Chapter.Chapter3} />
          </Route>
          <Route path={AppLinkHrefs.Terms}>
            <Terms />
          </Route>
          <Route path={AppLinkHrefs.Subscribe}>
            <Subscribe />
          </Route>
          <Route path={AppLinkHrefs.Resources}>
            <Resources />
          </Route>
          <Route path={AppLinkHrefs.Gumroad}>
            <Gumroad />
          </Route>
          <Route path={AppLinkHrefs.Home}>
            <Product />
          </Route>
        </Switch>
      </Router>
    </React.Fragment>
  );
}

export default AppLayout;
